var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsletter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    clipPath: "url(#clip0_183_34)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_183_34)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_183_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8984 31.0609L15.0228 30.2197L16.691 34.4686L14.5666 35.3098L12.8984 31.0609Z",
    fill: "#23DDCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5551 30.049V35.0535L37.3363 52.7189L3.11755 35.0678V30.6051L37.3363 3.55801L40.2449 5.85352L41.6564 4.05703L37.3363 0.649414L0.836304 29.5072V73.407H73.8363V30.0633H71.5551V30.049ZM3.11755 37.6342L34.8554 54.0164L3.11755 70.3844V37.6342ZM6.66775 71.1115L37.3363 55.2854L68.0049 71.1115H6.66775ZM71.5551 70.3844L39.8172 54.0021L71.5551 37.6342V70.3844Z",
    fill: "#23DDCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5554 21.5934L15.8783 26.1986L20.0701 36.8064L24.3189 35.1383L28.083 44.691L34.442 42.1816L30.6779 32.6289L31.733 32.2154C37.7355 29.7631 44.4652 29.7488 50.482 32.1727L52.9629 33.1992L42.3836 6.39453L41.2715 8.83262C38.534 14.7068 33.615 19.2836 27.5554 21.5934ZM21.3533 33.8551L18.8439 27.4961L27.3273 24.1455L29.8367 30.5045L21.3533 33.8551ZM31.4906 40.8842L29.3662 41.7254L26.4291 34.2971L28.5535 33.4559L31.4906 40.8842ZM48.9422 29.1928C43.3816 27.5674 37.4361 27.7385 31.9754 29.7061L29.4232 23.2473C34.7556 20.966 39.2183 17.0309 42.1697 12.0406L48.9422 29.1928Z",
    fill: "#23DDCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8642 13.8803C68.8888 18.9418 68.789 24.6021 66.6076 29.5924L68.7035 30.5049C73.708 18.9418 68.4183 5.51094 56.8552 0.492188L55.9427 2.58809C60.9472 4.74102 64.8824 8.80449 66.8642 13.8803Z",
    fill: "#23DDCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5053 16.3893C61.8455 19.7684 61.7885 23.5324 60.3342 26.8545L62.4301 27.7527C65.9232 19.6543 62.2162 10.2727 54.132 6.75098L53.2195 8.84687C56.5558 10.3012 59.1793 13.0102 60.5053 16.3893Z",
    fill: "#23DDCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0465 24.1463L56.1424 25.0588C58.1385 20.4393 56.0283 15.0641 51.4088 13.0537L50.4963 15.1496C53.9609 16.6467 55.5578 20.6816 54.0465 24.1463Z",
    fill: "#23DDCA"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_183_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    fill: "white",
    transform: "translate(0.836304 0.492188)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_183_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    fill: "white",
    transform: "translate(0.836304 0.492188)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_183_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    fill: "white",
    transform: "translate(0.836304 0.492188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletter);
export default __webpack_public_path__ + "static/media/newsletter.13b0952dd621fcec22f65e618f68f958.svg";
export { ForwardRef as ReactComponent };